import React, { useContext, useState } from "react";
import SearchFormContent from "../../components/view/hotel/search-form-content";
import { LocaleContext } from "../../routing/LangRouter";

function HotelSearch({ isHotelInternational, type }) {
    const { locale } = useContext(LocaleContext);
    const [uid, setUid] = useState();
    const [requestFlag, setRequestFlag] = useState(false);

    return (
        <SearchFormContent
            setRequestFlag={setRequestFlag}
            setUid={setUid}
            isHotelInternational={isHotelInternational}
            hotelRoute={`/${locale}/hotel`}
            type={type}
        />
    );
}

export default HotelSearch;
